<header-bar [pageTitle]="title" [headingClass]="headingClass" [buttons]="headerButtons"></header-bar>

<div class="container mt-5">
    <div class="row">
        <div class="col">
            <div class="card">
                <div class="card-header text-white bg-primary">
                    <div class="row">
                        <div class="col-sm-8">
                            <p class="h3 mt-1 mb-0">Manage timeline</p>
                        </div>
                        <div class="col-sm-4 text-right">
                            <button type="button" class="btn btn-outline-light btn-sm"
                                (click)="showHideDisableEvents()">
                                <span *ngIf="hideDisableEvents">Show disabled events</span>
                                <span *ngIf="!hideDisableEvents">Hide disabled events</span>
                                <i class="fa fa-filter ml-3"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="card-body">

                    <table class="table">
                        <colgroup>
                            <col class="col-auto">
                            <col class="col-auto">
                            <col class="col-auto">
                            <col class="col-auto">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Location</th>
                                <th>Description</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let event of events; let i = index">
                                <td [ngClass]="{'table__cell--disabled': event.disabled}">
                                    {{event.publishDate | date : 'd MMMM y'}}</td>
                                <td [ngClass]="{'table__cell--disabled': event.disabled}">
                                    <strong>{{event.country.name}}</strong></td>
                                <td [ngClass]="{'table__cell--disabled': event.disabled}"><span
                                        [innerHtml]="event.text"></span></td>
                                <!-- <td [ngClass]="{'table__cell--disabled': event.disabled}">{{event.url | truncate: [30]}}</td> -->
                                <td class="text-right" [ngClass]="{'table__cell--disabled': event.disabled}">
                                    <i class="fa fa-pencil btn btn-primary-invert" (click)="editEvent(event)"></i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>